import type { BlogPost } from "@/data/blogPosts";
import { getPillarsForPost } from "@/data/contentArchitecture";
import { parseTocItems } from "@/lib/tableOfContents";

/**
 * Desktop reading navigation is useful when an article has both an intentional
 * pillar relationship and enough primary sections to create a real reading
 * route. Short news posts retain the compact inline contents control only.
 */
export const STICKY_PILLAR_TOC_MIN_WORDS = 1600;
export const STICKY_PILLAR_TOC_MIN_PRIMARY_SECTIONS = 5;

export function isLongFormPillarArticle(post: Pick<BlogPost, "slug" | "content">): boolean {
  if (!getPillarsForPost(post.slug).length) return false;

  const wordCount = post.content.trim().split(/\s+/).filter(Boolean).length;
  const primarySectionCount = parseTocItems(post.content).filter((item) => item.level === 2).length;

  return wordCount >= STICKY_PILLAR_TOC_MIN_WORDS
    && primarySectionCount >= STICKY_PILLAR_TOC_MIN_PRIMARY_SECTIONS;
}
